import { Dialog as MuiDialog } from '@mui/material';

import { DialogProps } from './Dialog';
import DialogInner from './DialogInner';

export default function DialogFullscreen({ title, children, onClose, actions, subtitle, ...props }: Omit<DialogProps, 'variant'>) {
    return (
        <MuiDialog fullScreen
            onClose={ onClose }
            { ...props }
        >
            <DialogInner title={ title }
                subtitle={ subtitle }
                onClose={ onClose }
                actions={ actions }
            >
                { children }
            </DialogInner>
        </MuiDialog>
    );
}
